export default "__VITE_ASSET__syBkgjDZ__"